import React from "react";

const SvgCapricorn = (props) => {
  return (
    <svg
      viewBox="0 0 44.9 41.92"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M35.07 25.65c-4.14 0-7.11 1.96-9.74 4.37-1.11-4.32-1.05-9.97-.98-15.5.02-1.33.03-2.66.03-3.98C24.38 3.3 19.95 0 15.85 0c-2.75 0-5.52 1.45-7.18 4.25-.5-.88-1.11-1.61-1.86-2.17C4.22.15 1.2 1.02 1.07 1.05.28 1.29-.17 2.11.06 2.9c.23.79 1.05 1.25 1.85 1.03.02-.01 1.76-.47 3.13.57 1.36 1.04 2.09 3.33 2.09 6.62v21.67c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V10.38c0-5.07 2.96-7.38 5.72-7.38 2.75 0 5.53 2.33 5.53 7.54 0 1.31-.01 2.63-.03 3.95-.08 6.66-.15 13.06 1.55 17.93-.06.06-.11.12-.17.18-3.17 3.25-6.17 6.32-10.91 6.32-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5c5.63 0 9.27-3.38 12.44-6.59.47.77 1.02 1.48 1.65 2.12 2.2 2.22 5.28 3.35 9.17 3.35 2.96 0 5.45-.75 7.22-2.17 1.68-1.35 2.61-3.21 2.61-5.24-.01-3.85-3.39-7.74-9.84-7.74zm5.34 10.64c-1.23.99-3.08 1.51-5.34 1.51-3.09 0-5.4-.8-7.03-2.46a8.93 8.93 0 01-1.58-2.24c2.5-2.45 5.07-4.44 8.61-4.44 4.48 0 6.83 2.38 6.83 4.73 0 1.1-.53 2.13-1.49 2.9z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default SvgCapricorn;
